import { Node } from 'slate';

import { el } from 'redom';

import SaveButton from 'generics/components/save-button';
import TextInputRow from 'generics/components/text-input-row';
import AdvancedSettingsContainer from 'generics/components/advanced-settings-container';

import AdvancedFormSettings from './advanced-settings';

import {
  determineRedirectPathInputValue
} from './utilities';

class ButtonOptionsForm {

  constructor(configuration, dialogCallbacks) {

    this.page = configuration.page;
    this.options = { ...configuration.data.options };
    this.buttonText = Node.string(configuration.data);
    this.onSave = dialogCallbacks.onComplete;

    this.buttonTextInputRow = null;
    this.redirectPathInputRow = null;
    this.advancedFormSettings = new AdvancedFormSettings({
      detailsEditor: this,
      data: this.options,
      handleBuilder: configuration.handleBuilder,
      onChange: this.handleAdvancedFormSettingsChange.bind(this)
    });
    this.advancedSettingsSection = new AdvancedSettingsContainer({
      label: 'Advanced settings',
      content: this.advancedFormSettings
    });

    this.el = el('div.form-details-editor-main', [
      this.renderInputsSection(),
      this.renderControlsSection()
    ]);

  }

  renderInputsSection() {

    return el('.form-details-editor-inputs-section', [
      // this.rendeButtonTextInputRow(),
      this.renderRedirectPathInputRow(),
      this.advancedSettingsSection
    ]);

  }

  rendeButtonTextInputRow() {
    this.buttonTextInputRow = new TextInputRow({
      class: 'columns',
      label: 'Button text',
      placeholder: 'Click me!',
      value: this.buttonText,
      onChange: this.handleButtonTextInputChange.bind(this)
    });

    return this.buttonTextInputRow;

  }

  renderRedirectPathInputRow() {

    this.redirectPathInputRow = new TextInputRow({
      label: 'Redirect path',
      placeholder: '/path',
      value: determineRedirectPathInputValue(this.options.clickHandler || '', this.page),
      onChange: this.handleRecirectPathChange.bind(this)
    });

    return this.redirectPathInputRow;

  }

  renderSaveButton() {

    const saveButton = new SaveButton({
      label: 'Save',
      onClick: this.handleSaveButtonClick.bind(this)
    });

    return saveButton;

  }

  renderControlsSection() {

    return el('.form-details-editor-controls-section', [
      el('.placeholder'),
      this.renderSaveButton()
    ]);

  }

  refreshRedirectPath() {

    const redirectPath = determineRedirectPathInputValue(this.options.clickHandler || '', this.page);

    this.redirectPathInputRow.input.setValue(redirectPath);

  }

  handleButtonTextInputChange(event, label) {

    this.options.buttonText = label;

  }

  handleRecirectPathChange(event, redirectPath) {

    this.advancedFormSettings.buildClickHandlerForPath(redirectPath);

  }

  handleAdvancedFormSettingsChange(data) {

    this.options.clickHandler = data.clickHandler;

  }

  handleSaveButtonClick() {

    this.onSave({
      buttonText: this.buttonText,
      options: this.options
    });

  }

  onmount() {

    this.redirectPathInputRow.input.focus();

  }

}

export default ButtonOptionsForm;